var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-table',_vm._g(_vm._b({staticClass:"table",attrs:{"row-class-name":"row","border":""}},'el-table',_vm.$attrs,false),_vm.$listeners),[(_vm.selection)?_c('el-table-column',{attrs:{"type":"selection","width":"26"}}):_vm._e(),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }